import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Clapperboard } from "lucide-react";
import { API } from "@/lib/auth";
import CinematicIntro from "./CinematicIntro";
import IntroEditorDialog from "./IntroEditorDialog";

const BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");

// Generic intro for client demos without a dedicated page.
export default function DemoIntroLayer({ slug }) {
  const [intro, setIntro] = useState(null);
  const [show, setShow] = useState(true);
  const [editor, setEditor] = useState(false);
  const [isAdmin] = useState(() => { try { return !!localStorage.getItem("nex_token"); } catch { return false; } });

  useEffect(() => {
    axios.get(`${API}/demos/${slug}/intro`).then(({ data }) => setIntro(data)).catch(() => setShow(false));
  }, [slug]);
  const done = useCallback(() => setShow(false), []);

  const endpoints = {
    save: `/admin/demos/${slug}/intro/narration`,
    reset: `/admin/demos/${slug}/intro/narration/reset`,
    preview: `/admin/demos/${slug}/intro/narration/preview`,
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setShow(true)}
        disabled={!intro}
        data-testid="client-demo-intro-replay"
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white/5 hover:bg-emerald-500/10 text-slate-300 hover:text-emerald-300 border border-white/10 hover:border-emerald-500/40 font-mono text-[11px] font-semibold tracking-[0.14em] uppercase whitespace-nowrap transition-colors disabled:opacity-40"
      >
        <Clapperboard className="w-3.5 h-3.5" /> Replay intro
      </button>
      {show && intro && (
        <CinematicIntro
          intro={intro}
          audioUrl={intro.narration?.url ? `${BASE}${intro.narration.url}` : null}
          musicUrl={intro.music_url ? `${BASE}${intro.music_url}` : null}
          isAdmin={isAdmin}
          onEdit={() => { setShow(false); setEditor(true); }}
          onDone={done}
        />
      )}
      {isAdmin && intro && (
        <IntroEditorDialog
          open={editor}
          onOpenChange={setEditor}
          slug={slug}
          intro={intro}
          narration={intro.narration}
          narrationStep={`intro-${slug}`}
          narrationEndpoints={endpoints}
          onSaved={setIntro}
          onLineSaved={(n) => setIntro((i) => ({ ...i, narration: n }))}
        />
      )}
    </>
  );
}
